import { render, staticRenderFns } from "./WidgetWrapper.vue?vue&type=template&id=2bdb680b&scoped=true"
import script from "./WidgetWrapper.vue?vue&type=script&lang=js"
export * from "./WidgetWrapper.vue?vue&type=script&lang=js"
import style0 from "./WidgetWrapper.vue?vue&type=style&index=0&id=2bdb680b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bdb680b",
  null
  
)

export default component.exports